import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initContentSlider() {
    const sliderElement = document.querySelector('.js-content-slider');

    if (!sliderElement) return;

    new Swiper(sliderElement, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.2,
        spaceBetween: 12,
        loop: false,
        pagination: {
            el: '.swiper-content-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.c_swiper-contentsliderblock-next',
            prevEl: '.c_swiper-contentsliderblock-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1
            },
        },
    });
}
